import { Options, Vue } from 'vue-class-component';
import { AppNewsRoutesEnum } from '../../router/AppNewsRoutesEnum';
import { SessionStorageEnum } from '@/utils/SessionStorageEnum';
import { appNewsService } from '@services/app-news.service';
import { FilterMatchMode } from 'primevue/api';
import { AppNews } from '@/model/AppNews';

import { AppTable } from '@sharedComponents';
import { PageHeader } from '@/components';

@Options({
  components: {
    AppTable,
    PageHeader,
  },
  beforeRouteEnter(to, from, next) {
    if (from.name && !(from.name as string).startsWith('app-news')) {
      sessionStorage.removeItem(SessionStorageEnum.TABLE_STATE_APP_NEWS);
    }

    next();
  },
  beforeRouteLeave() {
    if (this.service?.cancelPendingRequests) {
      this.service.cancelPendingRequests();
    }
  },
})
export default class AppNewsListPage extends Vue {
  filters: any = null;

  get service() {
    return appNewsService;
  }

  get stateKey() {
    return SessionStorageEnum.TABLE_STATE_APP_NEWS;
  }

  get newNewsRoute() {
    return {
      name: AppNewsRoutesEnum.APP_NEWS_DETAIL,
      params: { newsId: 'new' },
    };
  }

  get publishedOptions() {
    return [
      { label: 'Sì', value: '1' },
      { label: 'No', value: '0' },
    ];
  }

  goToDetail(news: AppNews) {
    this.$router.push({
      name: AppNewsRoutesEnum.APP_NEWS_DETAIL,
      params: { newsId: news.id },
    });
  }

  private initFilter() {
    this.filters = {
      title: {
        value: null,
        matchMode: FilterMatchMode.STARTS_WITH,
      },
      published: {
        value: null,
        matchMode: FilterMatchMode.EQUALS,
      },
    };
  }

  created() {
    this.initFilter();
  }
}
